import {
  VOID_UNASSIGN_BULK_GROUP_MESSAGE,
  VOID_UNASSIGN_GROUPED_HELPER_MESSAGE,
  VOID_UNASSIGN_SINGLE_MESSAGE,
} from "../constants";

const getFieldError = (field, value) => {
  switch (field) {
    case "comment":
      return value && value.trim() ? null : "* Required";
    case "voidReason":
      return value ? null : "* Required";
    default:
      return null;
  }
};

const getErrorInfo = (errorInfo, voidPickupData) => {
  const newErrorInfo = {};
  Object.keys(errorInfo).forEach((fieldName) => {
    newErrorInfo[fieldName] = getFieldError(
      fieldName,
      voidPickupData[fieldName]
    );
  });
  return newErrorInfo;
};

const getVoidUnassignMessage = (isBulkVoidPickup) =>
  isBulkVoidPickup ? VOID_UNASSIGN_BULK_GROUP_MESSAGE : VOID_UNASSIGN_SINGLE_MESSAGE;

const getVoidUnassignGroupedHelperMessage = ({ isGroupedPickups, isBulkVoidPickup }) =>
  isGroupedPickups && !isBulkVoidPickup ? VOID_UNASSIGN_GROUPED_HELPER_MESSAGE : null;

const getDefaultVoidPickData = () => ({
  voidReason: null,
  comment: null,
  errorInfo: {
    comment: null,
    voidReason: null
  },
});

export {
  getFieldError,
  getErrorInfo,
  getDefaultVoidPickData,
  getVoidUnassignMessage,
  getVoidUnassignGroupedHelperMessage,
};
